import { useState, useEffect } from "react";
import Header from "./components/Header";
import Button from "./components/Button";
import Card from "./components/Card";
import "./Admin.css";

const API       = '/api/blog';
const API_PENS  = '/api';

export default function Admin({ onGoHome }) {
  const [authed,   setAuthed]   = useState(false);
  const [password, setPassword] = useState('');
  const [posts,    setPosts]    = useState([]);
  const [pens,     setPens]     = useState([]);
  const [users,    setUsers]    = useState([]);
  const [tab,      setTab]      = useState('blog');
  const [view,     setView]     = useState('list');
  const [saving,   setSaving]   = useState(false);
  const [notif,    setNotif]    = useState('');
  const [curPw,     setCurPw]     = useState('');
  const [newPw,     setNewPw]     = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [pwSaving,  setPwSaving]  = useState(false);
  const [editPost, setEditPost] = useState({
    id:0, title:'', slug:'', excerpt:'', content:'',
    cover_image:'', tags:'', status:'draft'
  });

  const notify = (msg) => { setNotif(msg); setTimeout(()=>setNotif(''),3000); };

  const loadPosts = () => {
    fetch(`${API}/get_posts.php?status=published&limit=100`, {credentials:'include'})
      .then(r=>r.json()).then(d=>setPosts(d.posts||[]));
    fetch(`${API}/get_posts.php?status=draft&limit=100`, {credentials:'include'})
      .then(r=>r.json()).then(d=>setPosts(prev=>[...prev,...(d.posts||[])]));
  };

  const loadPens  = () => {
    fetch(`${API_PENS}/get_all_pens_admin.php`, {credentials:'include'})
      .then(r=>r.json()).then(d=>setPens(Array.isArray(d)?d:[]));
  };

  const loadUsers = () => {
    fetch(`${API_PENS}/get_all_users_admin.php`, {credentials:'include'})
      .then(r=>r.json()).then(d=>setUsers(Array.isArray(d)?d:[]));
  };

  useEffect(()=>{ if(authed){ loadPosts(); loadPens(); loadUsers(); } },[authed]);

  const login = async () => {
    try {
      const res  = await fetch(`${API_PENS}/admin_login.php`,{
        method:'POST', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({password})
      });
      const data = await res.json();
      if(data.success) setAuthed(true);
      else alert(data.message||'Wrong password!');
    } catch { alert('Network error!'); }
  };

  const autoSlug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');

  const handleTitleChange = (val) => {
    setEditPost(p=>({...p, title:val, slug:p.id?p.slug:autoSlug(val)}));
  };

  const savePost = async () => {
    if(!editPost.title||!editPost.content){alert('Title and content required!');return;}
    setSaving(true);
    try {
      const res  = await fetch(`${API}/save_post.php`,{
        method:'POST', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify(editPost)
      });
      const data = await res.json();
      if(data.success){ notify(editPost.id?'✓ Updated!':'✓ Created!'); loadPosts(); setView('list'); resetEditor(); }
      else notify('✗ '+( data.error||'Unknown'));
    } catch { notify('✗ Network error!'); }
    setSaving(false);
  };

  const deletePost = async (id) => {
    if(!window.confirm('Delete this post?')) return;
    const res  = await fetch(`${API}/delete_post.php`,{
      method:'POST', credentials:'include',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id})
    });
    const data = await res.json();
    if(data.success){ notify('✓ Post deleted!'); loadPosts(); }
  };

  const deletePen = async (pen_id) => {
    if(!window.confirm('Is pen ko delete karna chahte ho?')) return;
    try {
      const res  = await fetch(`${API_PENS}/admin_delete_pen.php`,{
        method:'POST', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({pen_id})
      });
      const data = await res.json();
      if(data.success){ notify('✓ Pen deleted!'); loadPens(); }
      else notify('✗ '+data.message);
    } catch { notify('✗ Network error!'); }
  };

  const deleteUser = async (user_id, name) => {
    if(!window.confirm(`"${name}" ko delete karna chahte ho?\nIs user ki saari pens bhi delete ho jaayengi!`)) return;
    try {
      const res  = await fetch(`${API_PENS}/admin_delete_user.php`,{
        method:'POST', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({user_id})
      });
      const data = await res.json();
      if(data.success){ notify('✓ User deleted!'); loadUsers(); loadPens(); }
      else notify('✗ '+data.message);
    } catch { notify('✗ Network error!'); }
  };

  const changePassword = async () => {
    if(newPw.length<8){ notify('✗ New password must be 8+ characters'); return; }
    if(newPw!==confirmPw){ notify('✗ New passwords do not match'); return; }
    setPwSaving(true);
    try {
      const res  = await fetch(`${API_PENS}/change_admin_password.php`,{
        method:'POST', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({current_password:curPw, new_password:newPw})
      });
      const data = await res.json();
      if(data.success){
        notify('✓ Password changed!');
        setCurPw(''); setNewPw(''); setConfirmPw('');
      } else notify('✗ '+(data.message||'Could not change password'));
    } catch { notify('✗ Network error!'); }
    setPwSaving(false);
  };

  const resetEditor = () => setEditPost({
    id:0,title:'',slug:'',excerpt:'',content:'',cover_image:'',tags:'',status:'draft'
  });

  const openEditor = (post=null) => {
    if(post) setEditPost(post); else resetEditor();
    setView('editor');
  };

  const formatDate = (d) => new Date(d).toLocaleDateString('en-US',{
    year:'numeric', month:'short', day:'numeric'
  });

  // Preview iframe srcdoc
  const buildPreview = (pen) => {
    return `<!DOCTYPE html><html><head><style>${pen.css||''}</style></head>
    <body>${pen.html||''}<script>${pen.js||''}</script></body></html>`;
  };

  // ── LOGIN ──
  if(!authed) return (
    <div className="admin-login">
      <Card className="admin-login-box">
        <div className="admin-login-logo">
          <img src="/logo.svg" alt="WSNCode" className="admin-login-logo-img" />
          <span className="admin-login-logo-suffix">Admin</span>
        </div>
        <p className="admin-login-sub">Management Panel</p>
        <input className="admin-input" type="password" placeholder="Enter admin password"
          value={password} onChange={e=>setPassword(e.target.value)}
          onKeyDown={e=>e.key==='Enter'&&login()} />
        <Button variant="primary" onClick={login}>Login →</Button>
        <Button variant="ghost"   onClick={onGoHome}>← Back to Site</Button>
      </Card>
    </div>
  );

  // ── EDITOR ──
  if(view==='editor') return (
    <div className="admin-page">
      <Header
        onLogoClick={onGoHome}
        leftExtra={<span className="admin-breadcrumb">Admin → {editPost.id?'Edit Post':'New Post'}</span>}
        rightExtra={
          <>
            {notif && <span className="admin-notif">{notif}</span>}
            <Button variant="ghost" onClick={()=>setView('list')}>← Back</Button>
            <select className="admin-select" value={editPost.status}
              onChange={e=>setEditPost(p=>({...p,status:e.target.value}))}>
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
            <Button variant="primary" onClick={savePost} disabled={saving}>
              {saving?'Saving...':'💾 Save Post'}
            </Button>
          </>
        }
      />
      <div className="admin-editor-layout">
        <div className="admin-editor-main">
          <input className="admin-title-input" placeholder="Post Title..."
            value={editPost.title} onChange={e=>handleTitleChange(e.target.value)} />
          <textarea className="admin-excerpt-input" rows={3}
            placeholder="Short excerpt..." value={editPost.excerpt}
            onChange={e=>setEditPost(p=>({...p,excerpt:e.target.value}))} />
          <div className="admin-content-label">Content (HTML supported)</div>
          <textarea className="admin-content-input" placeholder="Write content here..."
            value={editPost.content}
            onChange={e=>setEditPost(p=>({...p,content:e.target.value}))} />
        </div>
        <div className="admin-editor-sidebar">
          <Card className="admin-sidebar-card">
            <label className="admin-label">Slug (URL)</label>
            <input className="admin-input" placeholder="post-url-slug"
              value={editPost.slug} onChange={e=>setEditPost(p=>({...p,slug:e.target.value}))} />
            <p className="admin-hint">wsncode.com/blog/{editPost.slug||'post-slug'}</p>
          </Card>
          <Card className="admin-sidebar-card">
            <label className="admin-label">Cover Image URL</label>
            <input className="admin-input" placeholder="https://..."
              value={editPost.cover_image}
              onChange={e=>setEditPost(p=>({...p,cover_image:e.target.value}))} />
            {editPost.cover_image&&(
              <img src={editPost.cover_image} alt="cover" className="admin-img-preview"/>
            )}
          </Card>
          <Card className="admin-sidebar-card">
            <label className="admin-label">Tags (comma separated)</label>
            <input className="admin-input" placeholder="HTML, CSS, JavaScript"
              value={editPost.tags}
              onChange={e=>setEditPost(p=>({...p,tags:e.target.value}))} />
          </Card>
        </div>
      </div>
    </div>
  );

  // ── MAIN ──
  return (
    <div className="admin-page">
      <Header
        onLogoClick={onGoHome}
        leftExtra={<span className="admin-breadcrumb">Admin Panel</span>}
        rightExtra={
          <>
            {notif && <span className="admin-notif">{notif}</span>}
            <Button variant="ghost" onClick={onGoHome}>← Back to Site</Button>
            {tab==='blog' && (
              <Button variant="primary" onClick={()=>openEditor()}>+ New Post</Button>
            )}
          </>
        }
      />

      <div className="admin-container">

        {/* TABS */}
        <div className="admin-tabs">
          <button className={`admin-tab ${tab==='blog'?'active':''}`} onClick={()=>setTab('blog')}>
            📝 Blog Posts ({posts.length})
          </button>
          <button className={`admin-tab ${tab==='pens'?'active':''}`} onClick={()=>setTab('pens')}>
            🖊️ Explorer Pens ({pens.length})
          </button>
          <button className={`admin-tab ${tab==='users'?'active':''}`} onClick={()=>setTab('users')}>
            👥 Users ({users.length})
          </button>
          <button className={`admin-tab ${tab==='settings'?'active':''}`} onClick={()=>setTab('settings')}>
            ⚙️ Settings
          </button>
        </div>

        {/* ── BLOG TAB ── */}
        {tab==='blog' && (
          <>
            <div className="admin-stats-row">
              <Card className="admin-stat-box">
                <span className="admin-stat-num">{posts.filter(p=>p.status==='published').length}</span>
                <span className="admin-stat-label">Published</span>
              </Card>
              <Card className="admin-stat-box">
                <span className="admin-stat-num">{posts.filter(p=>p.status==='draft').length}</span>
                <span className="admin-stat-label">Drafts</span>
              </Card>
              <Card className="admin-stat-box">
                <span className="admin-stat-num">{posts.reduce((a,p)=>a+(p.views||0),0)}</span>
                <span className="admin-stat-label">Total Views</span>
              </Card>
            </div>
            <Card className="admin-posts-table">
              <div className="admin-table-header">
                <span>Title</span><span>Status</span>
                <span>Views</span><span>Date</span><span>Actions</span>
              </div>
              {posts.length===0 && <div className="admin-no-posts">No posts yet! 🚀</div>}
              {posts.map(post=>(
                <div className="admin-table-row" key={post.id}>
                  <span className="admin-post-title">{post.title}</span>
                  <span className={`admin-status-badge ${post.status}`}>{post.status}</span>
                  <span className="admin-post-views">👁 {post.views||0}</span>
                  <span className="admin-post-date">{formatDate(post.created_at)}</span>
                  <span className="admin-post-actions">
                    <Button variant="ghost"  size="sm" onClick={()=>openEditor(post)}>✏️ Edit</Button>
                    <Button variant="danger" size="sm" onClick={()=>deletePost(post.id)}>🗑️</Button>
                  </span>
                </div>
              ))}
            </Card>
          </>
        )}

        {/* ── PENS TAB ── */}
        {tab==='pens' && (
          <div className="admin-pens-grid">
            {pens.length===0 && <div className="admin-no-posts">Koi pen nahi! 🤷</div>}
            {pens.map(pen=>(
              <Card className="admin-pen-card" key={pen.id}>
                {/* Live Preview */}
                <div className="admin-pen-preview">
                  <iframe
                    srcDoc={buildPreview(pen)}
                    title={pen.title}
                    sandbox="allow-scripts"
                    scrolling="no"
                  />
                </div>
                {/* Info */}
                <div className="admin-pen-info">
                  <span className="admin-pen-title">{pen.title||'Untitled'}</span>
                  <span className="admin-pen-meta">
                    👤 {pen.user_name||'Unknown'} · 📅 {formatDate(pen.created_at)}
                  </span>
                  <span className="admin-pen-meta">
                    👁 {pen.views||0} views · ❤️ {pen.likes||0} likes
                  </span>
                </div>
                <Button variant="danger" onClick={()=>deletePen(pen.id)}>
                  🗑️ Delete
                </Button>
              </Card>
            ))}
          </div>
        )}

        {/* ── USERS TAB ── */}
        {tab==='users' && (
          <Card className="admin-posts-table">
            <div className="admin-table-header">
              <span>Name</span>
              <span>Email</span>
              <span>Bio</span>
              <span>Website</span>
              <span>Joined</span>
              <span>Action</span>
            </div>
            {users.length===0 && <div className="admin-no-posts">Koi user nahi! 🤷</div>}
            {users.map(user=>(
              <div className="admin-table-row" key={user.id}>
                <span className="admin-post-title">👤 {user.name}</span>
                <span className="admin-post-date">{user.email}</span>
                <span className="admin-post-date">{user.bio||'—'}</span>
                <span className="admin-post-date">
                  {user.website
                    ? <a href={user.website} target="_blank" rel="noreferrer"
                        style={{color:'var(--accent)'}}>🔗 Link</a>
                    : '—'}
                </span>
                <span className="admin-post-date">{formatDate(user.created_at)}</span>
                <span className="admin-post-actions">
                  <Button variant="danger" size="sm" onClick={()=>deleteUser(user.id, user.name)}>
                    🗑️ Delete
                  </Button>
                </span>
              </div>
            ))}
          </Card>
        )}

        {/* ── SETTINGS TAB ── */}
        {tab==='settings' && (
          <Card className="admin-sidebar-card" style={{maxWidth:420}}>
            <label className="admin-label">Change Admin Password</label>
            <input className="admin-input" type="password" placeholder="Current password"
              value={curPw} onChange={e=>setCurPw(e.target.value)} />
            <input className="admin-input" type="password" placeholder="New password (8+ characters)"
              value={newPw} onChange={e=>setNewPw(e.target.value)} />
            <input className="admin-input" type="password" placeholder="Confirm new password"
              value={confirmPw} onChange={e=>setConfirmPw(e.target.value)}
              onKeyDown={e=>e.key==='Enter'&&changePassword()} />
            <Button variant="primary" onClick={changePassword} disabled={pwSaving}>
              {pwSaving?'Saving...':'Update Password'}
            </Button>
            <p className="admin-hint">You'll stay logged in on this device after changing it.</p>
          </Card>
        )}

      </div>
    </div>
  );
}